var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMember(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "team_1",
    "data-name": "team 1",
    transform: "translate(0.333 0.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(13.171 12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,5.322V12.6A2.027,2.027,0,0,0,2.021,14.62H2.8c9.866.221,6.077.566,9.466-.034h.775a2.027,2.027,0,0,0,2.021-2.021V2.021A2.027,2.027,0,0,0,13.037,0H2.021A2.005,2.005,0,0,0,0,2.021Z",
    transform: "translate(0 11.049)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.682,9.365A4.682,4.682,0,1,1,9.365,4.682,4.682,4.682,0,0,1,4.682,9.365Z",
    transform: "translate(2.83)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMember);
export default __webpack_public_path__ + "static/media/member.685f5f1d1a50d71e6164902bf4500cb4.svg";
export { ForwardRef as ReactComponent };